export const ADD_LOCATION = `ADD_LOCATION`;
export const UPDATE_LOCATION = `UPDATE_LOCATION`;
export const REMOVE_LOCATION = `REMOVE_LOCATION`;
export const SET_LOCATIONS = `SET_LOCATIONS`;
export const SEARCH_RESULT = `SEARCH_RESULT`;
export const SET_SEARCH_PARAMS = `SET_SEARCH_PARAMS`;
export const RESET_ALL = `RESET_ALL`;
export const UPDATE_AVAILABILITY = `UPDATE_AVAILABILITY`;
